import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useRemoteClientPost } from "../../../../../configs/http-client"
import { CatchMessageError } from "../../../../../remote/catch-message-error"
import { useLocalStorage } from "../../../../../remote/local-storage"

interface DateRange {
  dataInicial: Date | null
  dataFinal: Date | null
}

export const LoadCashRegisters = (dateRange?: DateRange) => {
  const { getUnitId } = useLocalStorage()
  const [loading, setLoading] = useState(false)
  const [params] = useSearchParams()
  const [data, setData] = useState<any>(null)
  const { httpClientPost } = useRemoteClientPost("finance") // Moved hook call to top level

  const formatDateToISO = (date: Date | null): string | null => {
    if (!date) return null

    // Criar uma nova data com horário específico
    const formattedDate = new Date(date)

    // Para data inicial, usar 00:00:00
    if (date === dateRange?.dataInicial) {
      formattedDate.setHours(0, 0, 0, 0)
    }

    // Para data final, usar 23:59:59
    if (date === dateRange?.dataFinal) {
      formattedDate.setHours(23, 59, 59, 999)
    }

    return formattedDate.toISOString()
  }

  const load = (idResponsalve?: number, statusCaixa?: string) => {
    setLoading(true)

    const body: any = {
      idUnidade: getUnitId(),
    }

    if (idResponsalve) {
      body.idResponsavel = idResponsalve
    }

    if (statusCaixa) {
      body.statusCaixa = statusCaixa
    }

    const dataInicial = dateRange?.dataInicial
      ? formatDateToISO(dateRange.dataInicial)
      : null

    const dataFinal = dateRange?.dataFinal
      ? formatDateToISO(dateRange.dataFinal)
      : null

    httpClientPost(`/caixa/filtro?page=${params.get("page") || 0}&size=10&sort=inclusao,desc`, {
      ...body,
      dataInicial,
      dataFinal,
    })
      .then((response) => {
        setData(response.data.data)
        setLoading(false)
      })
      .catch((error) => {
        CatchMessageError(error)
        setLoading(false)
      })
  }

  const reloadCashRegister = () => load()

  useEffect(() => {
    if (!loading) {
      load()
    }
  }, [params, dateRange])

  return {
    reloadCashRegister,
    data,
    loading,
  }
}
